import { useExtensionMenuItems } from '../../hooks/useExtensionMenuItems';

export const ExtensionMenuItems = {
  useExtensionMenuItems,
};

export type ExtensionMenuItemsType = {
  useExtensionMenuItems: typeof useExtensionMenuItems;
};
